// extracted by mini-css-extract-plugin
export var wrapperStyle = "sr_body_text-module--wrapperStyle--h9vob";